module.exports = __webpack_public_path__ + "ab05f19f08b765e2448d8c5536df9159.svg";